/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-10-09 14:07:08
 * @version 1.0.0
 */
import { TabsMap, NavigatorMap } from '@src/types';
export const ARTICLES_NAV_KEY_ARTICLE = 'article';
export const ARTICLES_NAV_KEY_QUESTION = 'question';
export const ARTICLES_NAV_KEY_ANSWER = 'answer';

export const ARTICLES_TABS_ARTICLE: TabsMap = {
  defaultActiveKey: '1',
  data: [
    {
      key: '1',
      title: '草稿',
      index: 'draft'
    },
    {
      key: '2',
      title: '发布',
      index: 'post'
    }
  ]
};

export const ARTICLES_TABS_QUESTION: TabsMap = {
  defaultActiveKey: '1',
  data: [
    {
      key: '1',
      title: '草稿',
      index: 'draft'
    },
    {
      key: '2',
      title: '发布',
      index: 'post'
    }
  ]
};

export const ARTICLES_TABS_ANSWER: TabsMap = {
  defaultActiveKey: '3',
  data: [
    {
      key: '3',
      title: '草稿',
      index: 'draft'
    },
    {
      key: '4',
      title: '发布',
      index: 'post'
    }
  ]
};

export const ARTICLES_TABS_MAP: { [navKey: string]: TabsMap } = {
  [ARTICLES_NAV_KEY_ARTICLE]: ARTICLES_TABS_ARTICLE,
  [ARTICLES_NAV_KEY_QUESTION]: ARTICLES_TABS_QUESTION,
  [ARTICLES_NAV_KEY_ANSWER]: ARTICLES_TABS_ANSWER
};

export const ARTICLES_NAV_TABS: NavigatorMap = {
  defaultActiveKey: ARTICLES_NAV_KEY_ARTICLE,
  data: [
    {
      key: ARTICLES_NAV_KEY_ARTICLE,
      title: '文章'
    },
    {
      key: ARTICLES_NAV_KEY_QUESTION,
      title: '提问'
    }
  ]
};
